import styled from 'styled-components';

export const CheckedIconStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0 8px;
`